import Events from "actions/events";
/**
 * state : {
 * 		productions :
 * 			[123356] : {
 * 				seriesSummary : {
		  			clientId:37
					daysOnSale:813
					productionId:2111
					productionName:"Another GA series"
					remainingDays:0
					totalComps:0
					totalSeatsAvailable:0
					totalSeriesHolds:0
					totalTicketsSold:1
					userId:9
					hasFuturePerformances: true
					dateInfo: {
						firstTransactionDate: 1495437062000
						lastTransactionDate: 1495437062000
					}
		   		}
		  		goal : {
		  			ticketRevenueGoal:100
		  			ticketQuantitySoldGoal:100
		  		}
		  		salesRevenue: {
		  			dateInMilliseconds : cumulativeSalesRevenueForDay
		  			1495437062000 : 10
					1495437062000 : 20
		  		}
		  		stats : {
		  			ticketRevenueTotal: 10
		  			ticketQuantitySoldTotal: 10
		  		}
		  		ticketBreakDown: {
					ticketTypes: [
						0 : {
							@id:1
							ticketPrice:25
							ticketTypeId:4442
							ticketTypeKey:"Public-4442"
							ticketTypeName:"Public
						}
					]
					ticketsSoldByDay : {
						2017-06-21T04 : {
								Public-4442 : {
									date:"2017-06-21"
									numTicketsSold:1
									ticketPrice:50
									ticketType:24
									ticketTypeId:5571
									ticketTypeName:"adult"
									totalRevenueAsDouble:50
							}
						}
					}
	  			}
 * 			}
 *
 * }
 */
//prodcutions = [productionId][result];
var productions = [];
const ProductionSummaryReducer = (state = [], action) => {
	if(action.data && action.data.productionId) {
			var productionId = action.data.productionId;
		  	var result = {};
		  	if(productions[productionId]) {
		  		result = productions[productionId];
			  }
		  switch (action.type) {
		  	case Events.Series.SUMMARY_RECEIVE:
		  		result =  Object.assign({}, result, {seriesSummary : action.data.data});
		  		break;
		  	case Events.Series.TICKET_REVENUE_GOAL:
		    	var goal =  Object.assign({}, result.goal || {}, {ticketRevenueGoal: action.data.data});
		    	result =  Object.assign({}, result, {goal});
		    	break;
		    case Events.Series.TICKET_REVENUE:
		    	var stats =  Object.assign({}, result.stats || {}, {ticketRevenueTotal: action.data.data});
		    	result =  Object.assign({}, result, {stats});
		    	break;
		    case Events.Series.TICKET_QUANTITY_SOLD_GOAL:
		    	goal =  Object.assign({}, result.goal || {}, {ticketQuantitySoldGoal: action.data.data});
		    	result =  Object.assign({}, result, {goal});
		    	break;
		    case Events.Series.TICKET_QUANTITY_SOLD:
		    	stats =  Object.assign({}, result.stats || {}, {ticketQuantitySoldTotal: action.data.data});
		    	result =  Object.assign({}, result, {stats});
		    	break;
		    case Events.Series.SALES_REVENUE_RECEIVE:
					let salesRevenue = action.data.data;
					if(result.salesRevenue && salesRevenue[0].label !== result.salesRevenue[0].label){
		    			salesRevenue =  action.data.data.concat(result.salesRevenue)
					}
		    	result =  Object.assign({}, result, {salesRevenue});
		    	break;
		    case Events.Series.TICKET_BREAKDOWN_SALES_RECEIVE:
					let ticketBreakDown = action.data.data;
					if (result.ticketBreakDown)	{
		    			let ticketsSoldByDay =  Object.assign({}, result.ticketBreakDown.ticketsSoldByDay, ticketBreakDown.ticketsSoldByDay);
						ticketBreakDown = Object.assign({}, ticketBreakDown, {ticketsSoldByDay})
					}
		    	result =  Object.assign({}, result, {ticketBreakDown});
					break;
				case Events.Series.DNDTABLE_DATA_RECEIVE:
					// console.log("DNDTABLEINFO=====", action.data.data);
          result =  Object.assign({}, result, {dndTableData : action.data.data});
					break;
				case Events.Series.FEE_INCLUSION_RECEIVE:
					result =  Object.assign({}, result, { feeInclusion : action.data.data });
					break;
		    default:
		    	break;
		  }
		  productions[productionId] = result;
	}
	return {productions};
}

export default ProductionSummaryReducer;



// WEBPACK FOOTER //
// ./src/scripts/reducers/ProductionSummaryReducer.js